(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moebe-card-views"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('moebe-card-views')) return;
    let selectedView = 'product';
    const mobile = window.matchMedia('(max-width: 768px)');

    customElements.define('moebe-card-views', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.wrapper = this.closest('.collection-grid__wrapper');
        if (!this.wrapper) return;
        this.suppressedClicks = new WeakMap();
        this.preparedCards = new WeakSet();
        this.imageObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.prepareImage(entry.target);
            this.imageObserver.unobserve(entry.target);
          });
        }, { rootMargin: '500px 0px' });
        const refresh = () => this.sync(false);
        mobile.addEventListener('change', refresh, { signal });
        window.addEventListener('resize', refresh, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-card-view-toggle]');
          if (!button) return;
          selectedView = selectedView === 'product' ? 'lifestyle' : 'product';
          this.sync(true);
        }, { signal });
        this.wrapper.addEventListener('pointerdown', event => {
          this.gesture = null;
          if (!mobile.matches || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          const card = event.target.closest('.moebe-card-pair');
          if (!card) return;
          this.suppressedClicks.delete(card);
          this.gesture = { card, id: event.pointerId, x: event.clientX, y: event.clientY, axis: null };
          this.prepareImage(card);
          card.setPointerCapture?.(event.pointerId);
        }, { signal, passive: true });
        this.wrapper.addEventListener('dragstart', event => {
          if (mobile.matches && event.target.closest('.moebe-card-pair')) event.preventDefault();
        }, { signal });
        this.wrapper.addEventListener('pointermove', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.id !== event.pointerId) return;
          const x = Math.abs(event.clientX - gesture.x);
          const y = Math.abs(event.clientY - gesture.y);
          if (!gesture.axis && Math.max(x, y) > 10) {
            gesture.axis = x > y * 1.35 ? 'horizontal' : 'vertical';
          }
          if (gesture.axis === 'horizontal') this.suppressedClicks.set(gesture.card, Date.now() + 700);
        }, { signal, passive: true });
        this.wrapper.addEventListener('pointerup', event => {
          const gesture = this.gesture;
          this.gesture = null;
          if (!gesture || gesture.id !== event.pointerId || !mobile.matches) return;
          const x = Math.abs(event.clientX - gesture.x);
          const y = Math.abs(event.clientY - gesture.y);
          if (gesture.axis !== 'vertical' && x >= 35 && x > y * 1.35) {
            gesture.card.dataset.cardView = gesture.card.dataset.cardView === 'lifestyle' ? 'product' : 'lifestyle';
            this.suppressedClicks.set(gesture.card, Date.now() + 700);
          }
        }, { signal, passive: true });
        this.wrapper.addEventListener('pointercancel', () => { this.gesture = null; }, { signal, passive: true });
        this.wrapper.addEventListener('click', event => {
          const card = event.target.closest('.moebe-card-pair');
          if (card && event.detail !== 0 && Date.now() < (this.suppressedClicks.get(card) || 0)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        this.observer = new MutationObserver(() => this.sync(false));
        this.observer.observe(this.wrapper, { childList: true, subtree: true });
        queueMicrotask(() => { if (this.isConnected) this.sync(false); });
      }

      sync(reset) {
        const cards = this.wrapper.querySelectorAll('.grid__item-image-wrapper');
        let pairs = 0;
        cards.forEach(card => {
          if (!card.querySelector('.grid-product__secondary-image')) return;
          pairs += 1;
          if (reset || !card.classList.contains('moebe-card-pair')) card.dataset.cardView = selectedView;
          card.classList.add('moebe-card-pair');
          if (!this.preparedCards.has(card)) this.imageObserver.observe(card);
        });
        this.toggleAttribute('data-ready', pairs > 0);
        this.wrapper.classList.toggle('moebe-card-views-ready', pairs > 0);
        this.dataset.selectedView = selectedView;
        const sort = this.wrapper.querySelector('[name="SortBy"]');
        if (sort) {
          const font = getComputedStyle(sort);
          ['font-family', 'font-size', 'font-weight', 'line-height', 'letter-spacing'].forEach(property => {
            this.style.setProperty('--moebe-view-' + property, font.getPropertyValue(property));
          });
        }
        this.querySelectorAll('button').forEach(button => {
          button.setAttribute('aria-checked', String(selectedView === 'lifestyle'));
        });
      }

      prepareImage(card) {
        if (this.preparedCards.has(card)) return;
        const img = card.querySelector('.grid-product__secondary-image img');
        if (!img) return;
        this.preparedCards.add(card);
        const ready = () => {
          if (img.naturalWidth > 0) card.setAttribute('data-lifestyle-ready', '');
        };
        img.addEventListener('load', ready, { once: true, signal: this.controller.signal });
        img.decoding = 'async';
        img.loading = 'eager';
        if (img.complete) ready();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.imageObserver?.disconnect();
        this.gesture = null;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moebe-page-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moebe-page-navigation')) {
    customElements.define('moebe-page-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.inline = this.querySelector('[data-inline]');
        this.dock = this.querySelector('[data-dock]');
        this.links = [...this.querySelectorAll('a[href^="#"]')];
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        document.addEventListener('DOMContentLoaded', this.schedule, options);
        document.addEventListener('shopify:section:load', this.schedule, options);
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', link.hash);
          const heading = target.closest('.shopify-section')?.querySelector('h1, h2');
          if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
        }, options);
        this.resize = new ResizeObserver(this.schedule);
        this.resize.observe(document.body);
        this.schedule();
      }
      update() {
        if (!this.isConnected) return;
        const readingLine = Math.max(104, window.innerHeight * .25);
        const hideTarget = document.getElementById(this.dataset.hideAt)?.closest('.shopify-section');
        const hideRect = hideTarget?.getBoundingClientRect();
        const footer = document.querySelector('.site-footer')?.getBoundingClientRect();
        const hideAtContent = hideRect && hideRect.top <= readingLine && hideRect.bottom > readingLine;
        this.dockHeight = this.dock.offsetHeight || this.dockHeight || 56;
        const footerVisible = footer && footer.top < window.innerHeight - this.dockHeight;
        this.dock.hidden = this.inline.getBoundingClientRect().bottom >= 0 || Boolean(hideAtContent) || Boolean(footerVisible);
        let current = null;
        for (const link of this.querySelectorAll('[data-inline] a[href^="#"]')) {
          const target = document.getElementById(link.hash.slice(1));
          if (target && target.getBoundingClientRect().top <= readingLine) current = link.hash;
        }
        for (const link of this.links) {
          if (link.hash === current) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moebe-storage-lid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moebe-storage-lid')) {
    customElements.define('moebe-storage-lid', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-storage-config]').textContent);
        const c = this.config;
        this.variants = c.product.variants.filter(v => v.sku && !v.sku.startsWith('SET'));
        if (!this.variants.length) return;
        const selected = c.product.variants.find(v => String(v.id) === String(c.selectedId)) || this.variants[0];
        this.finish = selected.option1;
        this.wheels = c.standard ? selected.option3 : null;
        this.withLid = selected.sku.startsWith('SET') || new URL(location.href).searchParams.get('moebe_lid') === '1';
        this.form = this.querySelector('[data-storage-form]');
        this.button = this.querySelector('[data-storage-submit]');
        this.error = this.querySelector('[data-storage-error]');
        this.groups = {};
        this.addChoices('finish', c.standard ? c.strings.finish : c.strings.wire,
          [...new Set(this.variants.map(v => v.option1))].map(v => [v,v]));
        if (c.standard) this.addChoices('wheels', c.strings.wheels,
          [['Without wheels',c.strings.withoutWheels],['With wheels',c.strings.withWheels]]);
        this.addChoices('lid', c.strings.lid, [['0',c.strings.withoutLid],['1',c.strings.withLid]]);
        this.form.addEventListener('change', e => {
          if (e.target.name === 'storage-finish') this.finish = e.target.value;
          if (e.target.name === 'storage-wheels') this.wheels = e.target.value;
          if (e.target.name === 'storage-lid') this.withLid = e.target.value === '1';
          if (!this.baseVariant() && c.standard) this.wheels = 'Without wheels';
          this.error.hidden = true;
          this.update(true);
        });
        this.form.addEventListener('submit', e => this.submit(e));
        this.update(false);
        this.hidden = false;
        this.imageReady = () => this.updateImage();
        document.addEventListener('page:loaded', this.imageReady, {once:true});
        window.addEventListener('load', this.imageReady, {once:true});
        requestAnimationFrame(this.imageReady);
      }
      addChoices(key, title, choices) {
        const wrapper = document.createElement('div');
        wrapper.className = 'variant-wrapper js';
        wrapper.dataset.type = 'button';
        const heading = document.createElement('label');
        heading.className = 'variant__label';
        heading.textContent = title;
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'variant-input-wrap';
        fieldset.id = `StorageOption-${this.dataset.sectionId}-${this.config.product.id}-${key}`;
        heading.htmlFor = fieldset.id;
        const legend = document.createElement('legend');
        legend.className = 'hide';
        legend.textContent = title;
        fieldset.append(legend);
        this.groups[key] = [];
        for (const [value,labelText] of choices) {
          const option = document.createElement('div');
          option.className = 'variant-input';
          const input = document.createElement('input');
          input.type = 'radio'; input.name = `storage-${key}`; input.value = value;
          input.id = `${fieldset.id}-${this.groups[key].length}`;
          const label = document.createElement('label');
          label.className = 'variant__button-label';
          label.htmlFor = input.id;
          label.textContent = labelText;
          option.append(input,label); fieldset.append(option); this.groups[key].push(input);
        }
        wrapper.append(heading,fieldset);
        this.querySelector('[data-storage-choices]').append(wrapper);
      }
      baseVariant() {
        return this.variants.find(v => v.option1 === this.finish && (!this.config.standard || v.option3 === this.wheels));
      }
      matchingLid() {
        const base = this.baseVariant();
        if (!base) return null;
        let sku = 'LIDSBO';
        if (this.config.smallLid) sku = 'LIDSBO1';
        else if (base.sku.includes('SO')) sku = 'LIDSBSO';
        else if (base.sku === 'SBER') sku = 'LIDSBER';
        else if (base.sku === 'SBWG') sku = 'LIDSBWG';
        return (this.config.lids || []).find(v => v.sku === sku);
      }
      update(changeUrl) {
        const base = this.baseVariant(), lid = this.matchingLid(), s = this.config.strings;
        for (const input of this.groups.finish) input.checked = input.value === this.finish;
        for (const input of this.groups.wheels || []) {
          input.checked = input.value === this.wheels;
          input.disabled = !this.variants.some(v => v.option1 === this.finish && v.option3 === input.value);
          input.nextElementSibling.classList.toggle('disabled', input.disabled);
        }
        for (const input of this.groups.lid) input.checked = input.value === (this.withLid ? '1' : '0');
        this.button.disabled = this.busy || !base?.available || (this.withLid && !lid?.available);
        this.button.textContent = this.busy ? s.adding : this.button.disabled ? s.soldOut : s.add;
        const priceText = base ? (this.withLid && lid ? this.config.prices[base.id].lids[lid.id] : this.config.prices[base.id].base) : s.unavailable;
        const section = this.closest('[data-section-type="product"]');
        for (const price of section?.querySelectorAll('[data-product-price]') || []) price.textContent = priceText;
        if (this.withLid && !lid?.available) {
          this.error.textContent = s.lidUnavailable; this.error.hidden = false;
        }
        if (changeUrl) this.updateImage();
        if (changeUrl && base && section?.dataset.history === 'true') {
          const url = new URL(location.href);
          url.searchParams.set('variant',base.id);
          if (this.withLid) url.searchParams.set('moebe_lid','1'); else url.searchParams.delete('moebe_lid');
          history.replaceState({},'',url);
        }
      }
      updateImage() {
        const base = this.baseVariant();
        const mediaId = this.config.imageMap[base?.sku]?.[this.withLid ? '1' : '0'];
        const media = this.config.media.find(item => item.id === mediaId);
        const section = this.closest('[data-section-type="product"]');
        if (!media?.preview_image || !section?.querySelector(`.product__thumb[data-id="${mediaId}"]`)) return;
        const variant = {...base, featured_media:media, featured_image:media.preview_image};
        section.dispatchEvent(new CustomEvent('variantImageChange', {detail:{variant}}));
      }
      disconnectedCallback() {
        document.removeEventListener('page:loaded', this.imageReady);
        window.removeEventListener('load', this.imageReady);
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const base = this.baseVariant(), lid = this.matchingLid();
        if (!base?.available || (this.withLid && !lid?.available)) return;
        const quantity = Number(new FormData(this.form).get('quantity'));
        if (!Number.isSafeInteger(quantity) || quantity < 1) return;
        const items = [{id:base.id,quantity}];
        if (this.withLid) items.push({id:lid.id,quantity});
        this.busy = true; this.error.hidden = true; this.update(false);
        try {
          const response = await fetch(this.config.addUrl, {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.config.strings.error);
          location.assign(this.config.cartUrl);
        } catch(error) {
          this.error.textContent = error.message === 'Failed to fetch' ? this.config.strings.error : error.message;
          this.error.hidden = false;
          this.busy = false; this.update(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
